var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContactsFound = function SvgContactsFound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 11.5,
    width: 68,
    height: 68,
    rx: 34,
    fill: "white",
    stroke: "#787878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 51.3333C28.3102 51.3333 23.2503 54.0545 20.0289 58.2773C19.3356 59.1861 18.9889 59.6406 19.0003 60.2547C19.009 60.7292 19.3099 61.3278 19.6868 61.6208C20.1747 62 20.8507 62 22.2029 62H45.7971C47.1493 62 47.8253 62 48.3132 61.6208C48.6901 61.3278 48.991 60.7292 48.9997 60.2547C49.0111 59.6406 48.6644 59.1861 47.9711 58.2773C44.7497 54.0545 39.6898 51.3333 34 51.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 46C38.4607 46 42.0768 42.4183 42.0768 38C42.0768 33.5817 38.4607 30 34 30C29.5393 30 25.9232 33.5817 25.9232 38C25.9232 42.4183 29.5393 46 34 46Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51.3333C28.3102 51.3333 23.2503 54.0545 20.0289 58.2773C19.3356 59.1861 18.9889 59.6406 19.0003 60.2547C19.009 60.7292 19.3099 61.3278 19.6868 61.6208C20.1747 62 20.8507 62 22.2029 62H45.7971C47.1493 62 47.8253 62 48.3132 61.6208C48.6901 61.3278 48.991 60.7292 48.9997 60.2547C49.0111 59.6406 48.6644 59.1861 47.9711 58.2773C44.7497 54.0545 39.6898 51.3333 34 51.3333Z",
    stroke: "#787878",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 46C38.4607 46 42.0768 42.4183 42.0768 38C42.0768 33.5817 38.4607 30 34 30C29.5393 30 25.9232 33.5817 25.9232 38C25.9232 42.4183 29.5393 46 34 46Z",
    stroke: "#787878",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.95431 48.9543 0 60 0C71.0457 0 80 8.95431 80 20C80 31.0457 71.0457 40 60 40C48.9543 40 40 31.0457 40 20Z",
    fill: "#F7F7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20C44 11.1634 51.1634 4 60 4C68.8366 4 76 11.1634 76 20C76 28.8366 68.8366 36 60 36C51.1634 36 44 28.8366 44 20Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5858 16.4142L58 24L55.4142 21.4142M60 4C51.1634 4 44 11.1634 44 20C44 28.8366 51.1634 36 60 36C68.8366 36 76 28.8366 76 20C76 11.1634 68.8366 4 60 4Z",
    stroke: "#36D593",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactsFound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contactsFound.01e9dadd.svg";
export { ForwardRef as ReactComponent };